import { RootState } from '../../../store';

export const selectGroupByUserSetting = (state: RootState): boolean => state.schedulerViewSettings.groupByUser;
